import { Component, OnInit } from '@angular/core';

import { UtilityService, AuthService, AppInformationService, ArkUnitOfWork } from 'app/core/core.module';
import { DevExtremeModule } from 'devextreme-angular';
import { confirm, alert } from 'devextreme/ui/dialog';
import _ from 'lodash';

@Component({
    selector: 'app-statements',
    templateUrl: './statements.component.html',
    styleUrls: ['./statements.component.css'],
    imports: [DevExtremeModule],
    standalone: true,
})
export class StatementsComponent implements OnInit {
    families: any[];
    filter: any;
    givingYears: any;
    canPrintStatement = false;

    constructor(private uow: ArkUnitOfWork, private utility: UtilityService, private auth: AuthService, public appInfo: AppInformationService) {}

    async ngOnInit() {
        this.givingYears = _.sortBy(this.uow.lookups.givingYears);
        this.filter = { givingYear: this.givingYears[this.givingYears.length - 1], rmd: false };
        this.families = await this.uow.getFamilies();
        if (this.appInfo.graafschap) this.canPrintStatement = this.auth.hasRole('Administrator') || this.auth.hasRole('Treasurer') || this.auth.hasRole('Deacon');
        else this.canPrintStatement = this.auth.hasRole('Administrator') || this.auth.hasRole('Treasurer');
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons'
        });
    }

    async printStatement(familyId: number) {
        // console.log(familyId);
        const result = await this.utility.printFamilyStatement(familyId, this.filter.givingYear, this.filter.rmd);
    }
    async printYearlyStatement() {
        const result = await confirm(
            `Are you sure you want to create the yearly statements for all families for ${this.filter.givingYear ? this.filter.givingYear : new Date().getFullYear()}?`,
            'Create All Statements?'
        );
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        await this.utility.printYearlyStatements(this.filter.givingYear, this.filter.rmd);
        this.appInfo.pleaseWaitHide();
    }
}
